/** The email log page's URL search params (kept out of the lazily loaded page). */
export type EmailStatus = "sent" | "failed" | "skipped";

export interface EmailLogSearch {
  q?: string;
  kind?: string;
  status?: EmailStatus;
  from?: string;
  to?: string;
  user_id?: number;
  page?: number;
}

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/** The URL's search params (admin/sections.tsx). */
export function parseEmailLogSearch(
  s: Record<string, unknown>,
): EmailLogSearch {
  const page = Number(s.page);
  const user = Number(s.user_id);
  const str = (v: unknown) => (typeof v === "string" && v ? v : undefined);
  const from = str(s.from);
  const to = str(s.to);
  return {
    ...(str(s.q) ? { q: str(s.q) } : {}),
    ...(str(s.kind) ? { kind: str(s.kind) } : {}),
    ...(s.status === "sent" || s.status === "failed" || s.status === "skipped"
      ? { status: s.status }
      : {}),
    ...(from && DAY.test(from) ? { from } : {}),
    ...(to && DAY.test(to) ? { to } : {}),
    ...(Number.isInteger(user) && user > 0 ? { user_id: user } : {}),
    ...(Number.isInteger(page) && page > 1 ? { page } : {}),
  };
}
